// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Container, Grid, Tabs, Tab } from '@material-ui/core';
import Authentication from '../apiproducts/authentication';
import Binder from '../apiproducts/binder';
import Lists from '../apiproducts/lists';
import Lookup from '../apiproducts/lookups';
import OCR from '../apiproducts/ocr';
import Notifications from '../apiproducts/notifications';
import Billing from '../apiproducts/billing';
import TaxCaddy from '../apiproducts/taxcaddy';
import TabPanel from '../../components/tabpanel';
import SearchonMainPage  from '../../components/search/mainpage-search';
import GetApiproductContent from '../../data/cms/content/apiproducts';
import FindAPI from '../../components/apiproducts/findapi';
import NoSearchResult from '../../components/search/noresult-search';
import './style.css';
//import TaxCaddy from './taxcaddy';
//import Billing from './billing';

function AllCategories(props) {
    const { location } = props;
    var page = location.state ? location.state.page : 0;
    const [value, setValue] = React.useState(page);
    const [searchText, setSearchText] = React.useState('');
    const [GetApiproduct, setApiproductContent] = React.useState({});
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await GetApiproductContent();
            setApiproductContent(fetchedContent);
            setLoading(false);
            window.scrollTo(0, 0);
        };
        fetchContent();
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const isRender = (title, searchText) => {
        if (searchText) {
            return searchText.toLowerCase() === title.toLowerCase() || searchText.toLowerCase().includes(title.toLowerCase()) || title.toLowerCase().includes(searchText.toLowerCase());
        }
        return true;
    };

    const isRenderTitle = (list, searchText) => {
        if (searchText) {
          return list.some((row) => isRender(row.Title, searchText));
        }
        return true;
    };

    const isDisplayOnSearch = () => {
        const authenticationAPIs = GetApiproduct?.ApiProducts?.Authentication;
        const binderAPIs = GetApiproduct?.ApiProducts?.Binder?.Binders;
        const TaxCaddyAPIs = GetApiproduct?.ApiProducts?.TaxCaddy?.TaxCaddys;
        const ListsAPIs = GetApiproduct?.ApiProducts?.List?.Lists;
        const Lookup = GetApiproduct?.ApiProducts?.Lookup?.Looksups;
        const OcrAPIs = GetApiproduct?.ApiProducts?.ocr?.ocrdata;
        const NotificationAPIs = GetApiproduct?.ApiProducts?.Notification?.Notifications;
        const BillingAPIs = GetApiproduct?.ApiProducts?.Billing?.Billings;

        if (
            isRender(authenticationAPIs?.GetToken?.Title, searchText) ||
            isRender(authenticationAPIs?.OAuth?.Title, searchText) ||
            isRenderTitle(binderAPIs?.Binder, searchText) ||
            isRenderTitle(TaxCaddyAPIs?.TaxCaddy, searchText) ||
            isRenderTitle(ListsAPIs?.List, searchText) ||
            isRenderTitle(Lookup?.Looksup, searchText) ||
            isRender(OcrAPIs?.Title, searchText) ||
            isRenderTitle(NotificationAPIs?.Notification, searchText) ||
            isRender(BillingAPIs?.Billing?.Title, searchText)
        ) {
            return true;
        }
        return false;
    };

    return (
        <>
            <Grid container className="api">
                <Container>
                <SearchonMainPage handleSearch={(val) => setSearchText(val)} />
                    <Grid container className="apiproduct">
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            className="apiproduct-nav-bar"
                        >
                            <Typography
                                component="div"
                                className="apiproduct-nav"
                            >
                                <Typography
                                    component="div"
                                    className="apiproduct-filter"
                                >
                                    Filter by:
                                </Typography>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    className="apiproduct-tabs"
                                    variant="scrollable"
                                >
                                    <Tab label="ALL Categories" />
                                    <Tab label="Authentication" />
                                    <Tab label="Binder" />
                                    <Tab label="TaxCaddy" />
                                    <Tab label="Lists" />
                                    <Tab label="Lookups" />
                                    <Tab label="Billing" />
                                    <Tab label="Ocr" />
                                    <Tab label="Notifications (Webhooks)" />
                                </Tabs>
                            </Typography>
                        </Grid>                        
                    </Grid>
                {isDisplayOnSearch() ? (
                    <Grid
                        item
                        sm={12}
                        md={12}
                        lg={12}
                        className="apiproduct-section"
                    >
                        {/* Tab Values */}
                        <TabPanel value={value} index={0}>
                            {!loading ? (
                                <Authentication
                                    Content={GetApiproduct.ApiProducts.Authentication}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <Binder
                                    Content={GetApiproduct.ApiProducts.Binder.Binders}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <TaxCaddy
                                    Content={GetApiproduct.ApiProducts.TaxCaddy.TaxCaddys}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <Lists
                                    Content={GetApiproduct.ApiProducts.List.Lists}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <Lookup
                                    Content={GetApiproduct.ApiProducts.Lookup.Looksups}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <Billing
                                    Content={GetApiproduct.ApiProducts.Billing.Billings}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <OCR
                                    Content={GetApiproduct.ApiProducts.ocr.ocrdata}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}

                            {!loading ? (
                                <Notifications
                                    Content={GetApiproduct.ApiProducts.Notification.Notifications}
                                    Tabclick={false}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            {!loading ? (
                                <Authentication
                                    Content={GetApiproduct.ApiProducts.Authentication}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            {!loading ? (
                                <Binder
                                    Content={GetApiproduct.ApiProducts.Binder.Binders}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            {!loading ? (
                                <TaxCaddy
                                    Content={GetApiproduct.ApiProducts.TaxCaddy.TaxCaddys}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>  
                        <TabPanel value={value} index={4}>
                            {!loading ? (
                                <Lists
                                    Content={GetApiproduct.ApiProducts.List.Lists}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={5}>
                            {!loading ? (
                                <Lookup
                                    Content={GetApiproduct.ApiProducts.Lookup.Looksups}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={6}>
                            {!loading ? (
                                <Billing
                                    Content={GetApiproduct.ApiProducts.Billing.Billings}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={7}>
                            {!loading ? (
                                <OCR
                                    Content={GetApiproduct.ApiProducts.ocr.ocrdata}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={8}>
                            {!loading ? (
                                <Notifications
                                    Content={GetApiproduct.ApiProducts.Notification.Notifications}
                                    Tabclick={true}
                                    searchText={searchText}
                                />
                            ) : (' ')}
                        </TabPanel>                     
                    </Grid>
                    ) : (
                        <Grid container className="nosearch">
                            <NoSearchResult />
                        </Grid>
                    )}
                    {!loading ? (
                        <FindAPI Content={GetApiproduct.ApiProducts.Find} />
                    ) : ('')}
                </Container>
            </Grid>
        </>
    );
};

AllCategories.propTypes = {
    GetAllCategory: PropTypes.object,
    keys: PropTypes.array,
};

export default AllCategories;
